export default __webpack_public_path__ + "icon-rag75435c.png";